import {calcUserScore} from 'helpers/common-helper';
import {getDefaultExposure} from 'helpers/player-helper';
import Action from 'actions';
import BasePlayer from 'services/sports/default/base-player';
import {PlayersPoolBuilder} from 'services/players-pool/players-pool-builder';
import {getPlayerProjOwnFunctionality} from 'helpers/projected-ownership';
import {toFloat} from "helpers/number-helper";

export default class Player extends BasePlayer {
    createPoolsOfPlayers({incomingValues: {players}}) {
        const {playersLock} = Action.getState();

        let builder = new PlayersPoolBuilder(players);

        builder.addTaskOnScenario('position');
        builder.addTaskOnScenario('playerId');
        builder.addTaskOnScenario('teamAndPosition');
        builder.addTaskOnScenario('allowedPositions');
        builder.addTaskOnScenario('gameTeamPosName');
        builder.addTaskOnProperty('gameInfo');
        builder.addTaskOnProperty('team');
        builder.addTaskOnProperty('exposureMin', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMin > 0;
        });
        builder.addTaskOnProperty('exposureMax', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMax < 100;
        });

        return builder.execTasks();
    }

    getExpandedEntityParams({incomingValues = {}}) {
        const player = super.getExpandedEntityParams({incomingValues});
        const {userPointsType = 'adminPoints'} = incomingValues;
        const isDefender = player.positionName === 'DST';
        const sharpPoints = isDefender
            ? toFloat(player.adminPoints, 3)
            : toFloat(player.sharpPoints ?? 0, 3);
        const isSharpPointsCalculatedFromProps = isDefender
            ? false
            : (player.isSharpPointsCalculatedFromProps ?? false);

        player.isDefender = isDefender;
        player.sharpPoints = sharpPoints;
        player.isSharpPointsCalculatedFromProps = isSharpPointsCalculatedFromProps;
        player.grades = toFloat(player.grades);
        player.dvp = toFloat(player.dvp);
        player.userPoints = toFloat(player[userPointsType], 3);
        player.userScore = calcUserScore(player.userPoints, player.salary, player.userScoreMultiplier);
        player.projOwn = {...getPlayerProjOwnFunctionality(player)};

        return {
            ...player,
            resetExposure() {
                this.exposureMin = getDefaultExposure('min');
                this.exposureMax = getDefaultExposure('max');
            },
        };
    }

    getPlayerById({incomingValues: {id}}) {
        const state = Action.getState();
        const {preparedPlayers} = state.playersData;
        const players = preparedPlayers.groupedBy.playerId();

        const player = {...players[id]};
        player.position = player.position[0];

        return player;
    }
}
